import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Alert, Button } from "reactstrap";
import PropTypes from "prop-types";

const AlertUpdateApp = ({ onClick, type }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!onClick) {
      const timer = setTimeout(() => {
        dispatch({ type });
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  if (onClick) {
    return (
      <>
        <Alert color="primary" style={{ zIndex: 99999 }}>
          <h4 className="alert-heading">Aplikasi berhasil diperbaharui !</h4>

          <p>
            Untuk mendapatkan pengalaman menggunakan aplikasi terbaru anda bisa
            memperbaharui aplikasi !
          </p>

          <hr />

          <Button color="primary" onClick={onClick}>
            Perbaharui Sekarang
          </Button>
        </Alert>
      </>
    );
  }
};

AlertUpdateApp.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
};

export default AlertUpdateApp;
